/**
 * Format a DOB string to dd-mm-yyyy regardless of input format.
 * Handles:  yyyy-mm-dd (ISO), dd-mm-yyyy (already formatted), or any Date-parseable string.
 */
export function fmtDob(dob) {
  if (!dob) return '—';
  // Already dd-mm-yyyy
  if (/^\d{2}-\d{2}-\d{4}$/.test(dob)) return dob;
  // ISO yyyy-mm-dd
  if (/^\d{4}-\d{2}-\d{2}$/.test(dob)) {
    const [y, m, d] = dob.split('-');
    return `${d}-${m}-${y}`;
  }
  // Fallback: try parsing
  const dt = new Date(dob);
  if (!isNaN(dt)) {
    const d = String(dt.getDate()).padStart(2, '0');
    const m = String(dt.getMonth() + 1).padStart(2, '0');
    const y = dt.getFullYear();
    return `${d}-${m}-${y}`;
  }
  return dob;
}
